var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('v-button',{staticClass:"btn",class:{
      'btn-warning': !_vm.entry.is_erotic,
      'btn-success': _vm.entry.is_erotic
    },attrs:{"request":_vm.toggleErotic,"disabled":_vm.entry.is_primary}},[_vm._v("\n    18+\n  ")]),_vm._v(" "),(_vm.isFake)?_c('v-button',{staticClass:"btn",class:{
      'btn-warning': !_vm.entry.is_online,
      'btn-success': _vm.entry.is_online
    },attrs:{"request":_vm.toggleOnline}},[_vm._v("\n    Online\n  ")]):_c('v-button',{staticClass:"btn",class:{
      'btn-warning': !_vm.entry.is_public,
      'btn-success': _vm.entry.is_public
    },attrs:{"request":_vm.setPublic}},[_vm._v("\n    18>\n  ")]),_vm._v(" "),_c('v-button',{staticClass:"btn",class:{
      'btn-warning': !_vm.entry.is_primary,
      'btn-success': _vm.entry.is_primary
    },attrs:{"request":_vm.setPrimary,"disabled":_vm.entry.is_erotic}},[(_vm.entry.is_image)?_c('i',{staticClass:"fas fa-image"}):_vm._e(),_vm._v(" "),(_vm.entry.is_audio)?_c('i',{staticClass:"fas fa-headphones"}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fas fa-star"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }